import * as React from "react";
import { Column } from "primereact/column";
import { Modal, ModalHeader, ModalBody, ModalFooter, Row, Col, Button } from "reactstrap";
import { Link } from "react-router-dom";
import PageLayout from "../../components/PageLayout";
import useEntitiesList from "../../utils/listHookNew";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { renderHeader } from "../../components/TableUtils"
import { DataTable } from "primereact/datatable";
import { getDate, filterDate, DropdownFilterElement } from "../../components/TableUtils";
import Can from "../../auth/Can";
import roles from "../../auth/roles";
import { useAuth0 } from "../../auth/react-auth0-wrapper";
import { useHistory } from "react-router-dom";
import { deleteMarketing } from "../../api/marketing";
import classNames from 'classnames';

export default function MarketingList({ opt, activeTenant }) {
    const { domains, user } = useAuth0();

    const [result, loading, setLoading, globalFilter, setGlobalFilter, forceRefresh] = useEntitiesList("marketing", "startdate asc", `tenant_id='${activeTenant._id}'`, "");

    const [openModal, setOpenModal] = React.useState(false);
    const toggle = () => setOpenModal(!openModal);

    const { push } = useHistory();

    const onDelete = async id => {
        const value = await deleteMarketing(id);
        toggle();
        forceRefresh();
        return value;
    };

    const modalSection = () => (
        <Modal zIndex={2000} centered size="sm" isOpen={openModal ? true : false} backdrop={true}>
            <ModalHeader toggle={toggle}>
                Eliminazione Campagna Marketing
        </ModalHeader>
            <ModalBody>
                <p>Confermi di voler eliminare la Campagna Marketing?</p>
            </ModalBody>
            <ModalFooter>
                <Button color="link" className="btn-link-dark" onClick={toggle}>Annulla</Button>{' '}
                <Button color="danger" className="ml-auto" onClick={() => onDelete(openModal._id)}>Elimina</Button>
            </ModalFooter>
        </Modal>
    );

    const getHeader = () => {
        return (
            <Can
                roles={[roles.DEALER, roles.ADMIN, roles.MARKETING]}
                yes={() =>
                    <div className="action-container">
                        <Link
                            title="Aggiungi campagna"
                            className="btn btn-primary p-button-icon-only"
                            to={`marketing-add`}
                        >
                            <FontAwesomeIcon icon="mail-bulk" className="mr-2" />Nuova Campagna
                        </Link>
                    </div>
                }
                no={() => null}
            />
        );
    };

    const onRefresh = () => {
        forceRefresh();
        setGlobalFilter("");
    }

    const exportTable = () => {
        dtable.exportCSV();
    }

    const duplicateMarketing = async id => {
        push(`marketing-add/${id}`);
    };

    return (
        <PageLayout title={`Campagne Marketing - Dealer: ${activeTenant.name}`}>
            <Row>
                <Col>
                    <DataTable
                        loading={loading}
                        value={result}
                        rowsPerPageOptions={[5, 10, 20, 50, 100]}
                        className="p-datatable-hoverable-rows p-datatable-customers"
                        responsive
                        paginator={true}
                        autoLayout={false}
                        first={0}
                        rows={20}
                        totalRecords={result.length}
                        paginatorPosition="both"
                        header={renderHeader(loading, result.length, undefined, getHeader(), { globalFilter, setGlobalFilter, onRefresh }, exportTable)}
                        globalFilter={globalFilter}
                        emptyMessage={() => (<div className="text-center">Nessuna Campagna Marketing in tabella</div>)}
                        paginatorTemplate="RowsPerPageDropdown CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
                        currentPageReportTemplate="Visualizzati {first} di {last} Campagne su un totale di {totalRecords}"
                    >
                        <Column
                            field="attributes.description"
                            header="Titolo"
                            sortable
                            filter
                            filterMatchMode="contains"
                            style={{ wordWrap: "break-word" }}
                            body={(rowData, column) => {
                                return (
                                    <Link
                                        to={`/tenant/marketing/${rowData._id}`}
                                    >
                                        {rowData.attributes.description}
                                    </Link>
                                );
                            }}
                        />
                        <Column
                            field="startdate"
                            header="Data inizio"
                            sortable
                            filter
                            body={getDate}
                            filterMatchMode="custom"
                            filterFunction={filterDate}
                            style={{ wordWrap: "break-word" }}
                        />
                        <Column
                            field="enddate"
                            header="Data fine"
                            sortable
                            filter
                            body={getDate}
                            filterMatchMode="custom"
                            filterFunction={filterDate}
                            style={{ wordWrap: "break-word" }}
                        />
                        <Column
                            field="attributes.kmFrom"
                            header="Dal Km."
                            sortable
                            filter
                            filterMatchMode="contains"
                            style={{ wordWrap: "break-word" }}
                        />
                        <Column
                            field="attributes.kmTo"
                            header="Al Km."
                            sortable
                            filter
                            filterMatchMode="contains"
                            style={{ wordWrap: "break-word" }}
                        />
                        <Column
                            field="status"
                            header="Stato"
                            sortable
                            filter
                            style={{ wordWrap: "break-word", textAlign: "center" }}
                            filterElement={
                                <DropdownFilterElement
                                    field="status"
                                    options={[
                                        { label: "attivo", value: "attivo" },
                                        { label: "chiuso", value: "chiuso" },
                                        { label: "inserito", value: "inserito" }
                                    ]}
                                    onChange={e => dtable.filter(e.value, e.field)}
                                />
                            }
                            body={(rowData, column) => {
                                return (
                                    <span className={classNames('customer-badge', 'status-' + rowData.status)}>{rowData.status}</span>
                                );
                            }}
                        />
                        <Column
                            field="actions"
                            body={(rowData, column) => {
                                return (
                                    <div className="action-container">
                                        <Can
                                            roles={[roles.ADMIN, roles.DEALER, roles.MARKETING]}
                                            yes={() =>
                                                <React.Fragment>
                                                    <Link
                                                        title="Gestisci campagna"
                                                        className="btn btn-sm btn-primary p-button-icon-only"
                                                        to={`/tenant/marketing/${rowData._id}`}
                                                    >
                                                        <FontAwesomeIcon icon="pencil-alt" />
                                                    </Link>
                                                    <Button
                                                        color="secondary"
                                                        title="Duplica campagna"
                                                        onClick={() => duplicateMarketing(rowData._id)}
                                                        className="btn-sm p-button-icon-only"
                                                    >
                                                        <FontAwesomeIcon icon="copy" />
                                                    </Button>
                                                    <Can
                                                        roles={[roles.ADMIN]}
                                                        yes={() => (
                                                            <Button
                                                                color="danger"
                                                                title="Elimina campagna"
                                                                onClick={() => setOpenModal(rowData)}
                                                                className="btn-sm p-button-icon-only"
                                                            >
                                                                <FontAwesomeIcon icon="trash-alt" />
                                                            </Button>
                                                        )}
                                                        no={() => null}
                                                    />
                                                </React.Fragment>
                                            }
                                            no={() => null}
                                        />
                                    </div>
                                );
                            }}
                            style={{ wordWrap: "break-word" }}
                        />
                    </DataTable>
                </Col>
            </Row>
            {modalSection()}
        </PageLayout>
    );
}
